import React from 'react'
import SimpleModal from "components/SimpleModal";
import { useState } from "react";
import { IApi } from "utils/API";
import { TTranslate } from "utils/language";
import Translation from "utils/Language/Translation";
import { INotificationContext } from "utils/NotificationManager";
import { Alert, Button, FormGroup, Label } from 'reactstrap';
import ProcessingButton from 'components/ProcessingButton';
import { FormInput, FormState, Labeled } from 'component_utils/FormUtils';
import PasswordStrengthBar from 'react-password-strength-bar';
import { MdPassword } from 'react-icons/md';
import generator from 'generate-password-browser';

interface IResetPasswordProps {
  userId: number;
  api: IApi;
  T: TTranslate;
  notifications: INotificationContext;
}
const ResetPassword = ({ userId, api, T, notifications }: IResetPasswordProps) => {
  const [autogeneratedPassword, setAutogeneratedPassword] = useState('')
  const [state, setState] = useState(
    {} as {
      password_one: string;
      password_two: string;
    },
  );

  return (
    <>
      <SimpleModal
        title={<Translation name="T.settings.changePassword" />}
        fullscreen={false}
        onOpen={() => {
          setAutogeneratedPassword('')
          setState({
            password_one: '',
            password_two: '',
          });
        }}
        trigger={(open) => (
          <FormGroup>
            <Label>
              <Translation name="T.settings.changePassword" />
            </Label>
            <Button onClick={open} block>
              <Translation name="T.settings.changePassword" />
            </Button>
          </FormGroup>
        )}
        buttons={(close) => [
          <Button color='info' onClick={() => {
            const password = generator.generate({
              length: 12,
              numbers: true
            })
            setAutogeneratedPassword(password)
            setState((old: any) => ({
              ...old, 
              password_one: password,
              password_two: password
            }))
          }}>
            <MdPassword/>
          </Button>,
          <ProcessingButton
            disabled={state.password_one !== state.password_two || !state.password_one}
            color="primary"
            onClick={async () => {
              if (state.password_one !== state.password_two) {
                return notifications.add('danger', <Translation name="T.errors.passwordsShouldMatch" />);
              }
              // save the new user password
              await api.users.saveUserPassword(userId, { password: state.password_one });
              notifications.add('success', <Translation name="T.settings.passwordIsSaved" />);
              close();
            }}
            data-testid={'simple-modal-primary'}
          >
            <Translation name="T.misc.save" />
          </ProcessingButton>,
          <ProcessingButton color="secondary" onClick={close} data-testid={'simple-modal-secondary'}>
            <Translation name="T.misc.cancel" />
          </ProcessingButton>,
        ]}
      >
        <FormState state={state} setState={setState} onStateChange={() => {
          setAutogeneratedPassword('')
        }}>
          <Alert color="success" isOpen={!!autogeneratedPassword}>
            <Translation name={"T.misc.autogeneratedPassword"} params={{ password: autogeneratedPassword }} />
          </Alert>

          <Labeled title={<Translation name="T.settings.newPassword" />}>
            <FormInput path="password_one" hideInput realtime/>
          </Labeled>
          <Labeled title={<Translation name="T.settings.repeatPassword" />}>
            <FormInput path="password_two" hideInput realtime/>
          </Labeled>
          <div className='d-inline-block'>
            <PasswordStrengthBar 
              password={state.password_one} 
              onChangeScore={(score) => setState(old => ({...old, score: score}))} 
            />
          </div>
        </FormState>
      </SimpleModal>
    </>
  );
};

export default ResetPassword;